import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HostDetailsService } from 'src/app/host-details/host-details.service';
import { ToasterService } from 'src/app/toaster.service';
import { Toaster, ToasterType } from 'src/app/shared/types';
import { DataService } from '../../data.service';
import { SingleSearchableDropdown } from 'src/app/filter.service';
const SEARCH_BY = {
  MOBILE: 'mobile',
};

const HOST_PROFILE_TYPE = 'host';

const PLACEHOLDER = {
  [SEARCH_BY.MOBILE]: 'Search by Host number',
}

@Component({
  selector: 'app-host-search',
  templateUrl: './host-search.component.html',
  styleUrls: ['./host-search.component.css']
})
export class HostSearchComponent implements OnInit {
  mobile = '';
  public enteredNumber = false;
  public focus = false;
  public SEARCH_BY = SEARCH_BY;

  private _searchBy = SEARCH_BY.MOBILE;
  public set searchBy(value) {
    this._searchBy = value;
    this.placeholder = PLACEHOLDER[value];
  }

  public get searchBy() {
    return this._searchBy;
  }
  public searchKeyword = '';
  public placeholder = PLACEHOLDER[this.searchBy];
  public filterTypeSelect = new SingleSearchableDropdown({
    key: 'value',
    title: '',
    values: [
      SEARCH_BY.MOBILE,
    ],
    default: SEARCH_BY.MOBILE,
    onChange: (event) => {
      console.log(event);
      const filterType = event.value;
      this.searchBy = filterType;
    }
  })
  constructor(
    private router: Router,
    private activedRoute: ActivatedRoute,
    private hostSerivce: HostDetailsService,
    private toasterService: ToasterService,
    private dataservice: DataService,
  ) { }

  ngOnInit() {
    this.mobile = this.activedRoute.snapshot.paramMap.get('id');
    this.activedRoute.parent.params.subscribe(params => {
    });
  }

  async searchHost() {
    switch(this.searchBy) {
      case SEARCH_BY.MOBILE: {
        if (!this.isValidMobileNumber(this.searchKeyword)) {
          return;
        }
        this.mobile = this.searchKeyword;
        this.searchMobileNumber();
      };
    }
  }

  private isValidMobileNumber(mobile) {
    const testMob = new RegExp('[0-9]{10}');
    if (!testMob.test(mobile)) {
      this.toasterService.showToaster(new Toaster({
        type: ToasterType.WARNING,
        message: `Please enter a valid 10-digit mobile number`,
      }));
      return false;
    }
    return true;
  }

  searchMobileNumber() {
    this.hostSerivce.getHostByMobile(this.mobile)
    .subscribe((data: { roles: string[] }) => {
      if (!data.roles.includes(HOST_PROFILE_TYPE)) {
        this.toasterService.showToaster(new Toaster({
            type: ToasterType.WARNING,
            message: `User found but this is a not host user. Please search using the host mobile number`,
        }));
        this.router.navigate(['/host']);
        return;
      }
      this.dataservice.updateSearchCount(this.mobile);
      this.toasterService.showToaster(new Toaster({
        type: ToasterType.SUCCESS,
        message: `User found`,
      }));
      this.router.navigate([`/host/${this.mobile}`]);
      this.mobile = '';
      document.getElementById('searchHost').blur();
    }, err => {
      console.error(err);
      this.toasterService.showToaster(new Toaster({
        type: ToasterType.WARNING,
        message: `Unable to fetch this user, Please check the number again`,
        config: {
        }
      }));
    });
  }

}
